/* mo:mo Sprachwahl — Erstbesuch automatisch auf die passende Sprache stellen.
   Regel: Besucher aus DE/AT/CH bekommen Deutsch, alle anderen Englisch.

   Warum so und nicht per IP-Dienst: Liquid kennt die Besucher-IP nicht, und ein externer
   Geo-Dienst wäre ein zusätzlicher Request plus Datenschutz-Thema. Stattdessen zwei lokale
   Signale, in dieser Reihenfolge:
     1. localization.country — das Land, das Shopify dem Besuch zuordnet (Markets/IP).
     2. Zeitzone des Geräts — Europe/Berlin|Vienna|Zurich|Busingen decken DACH zuverlässig ab.
     3. Browsersprache als letzter Fallback.

   Eine einmal getroffene manuelle Wahl gewinnt IMMER und wird nie überschrieben. */
(function () {
  var cfg = document.currentScript;
  if (!cfg || window.Shopify && window.Shopify.designMode) return;

  var current   = cfg.getAttribute('data-current') || '';
  var available = (cfg.getAttribute('data-available') || '').split(',');
  var country   = (cfg.getAttribute('data-country') || '').toUpperCase();
  var MANUAL    = 'momo:lang-choice';
  var GUARD     = 'momo:lang-auto';

  try {
    /* Hat der Besucher den Schalter schon benutzt, bleibt es dabei. */
    if (localStorage.getItem(MANUAL)) return;
    /* Schleifenschutz: pro Sitzung höchstens ein automatischer Wechsel. */
    if (sessionStorage.getItem(GUARD)) return;
  } catch (e) { return; }

  var DACH = ['DE', 'AT', 'CH', 'LI'];
  if (!country) {
    try {
      var tz = (Intl.DateTimeFormat().resolvedOptions().timeZone || '');
      if (/Berlin|Vienna|Zurich|Busingen|Vaduz/i.test(tz)) country = 'DE';
      else if (tz) country = 'XX';
    } catch (e) { /* Zeitzone nicht ermittelbar */ }
  }

  var wanted;
  if (country && DACH.indexOf(country) > -1) wanted = 'de';
  else if (country) wanted = 'en';
  else wanted = (navigator.language || '').toLowerCase().indexOf('de') === 0 ? 'de' : 'en';

  if (available.indexOf(wanted) === -1) return;
  if (wanted === current) return;

  try { sessionStorage.setItem(GUARD, '1'); } catch (e) {}

  /* Über Shopifys Localization-Endpoint wechseln — setzt das Cookie serverseitig und
     funktioniert unabhängig von der späteren URL-Struktur (Subfolder oder Domain).
     _method=put ist Pflicht: ohne das Feld erkennt Shopify den POST nicht als Sprachwechsel
     und antwortet auf /localization mit 404. Der Liquid-Tag {% form 'localization' %} setzt
     es automatisch, hier muss es von Hand mit. */
  var root = cfg.getAttribute('data-root') || '/';
  if (root.charAt(root.length - 1) !== '/') root += '/'; // routes.root_url ist "/en" ohne Schrägstrich
  var f = document.createElement('form');
  f.method = 'POST';
  f.action = root + 'localization';
  f.style.display = 'none';
  function add(n, v) {
    var i = document.createElement('input');
    i.type = 'hidden'; i.name = n; i.value = v;
    f.appendChild(i);
  }
  add('form_type', 'localization');
  add('utf8', '✓');
  add('_method', 'put');
  add('locale_code', wanted);
  add('return_to', location.pathname + location.search);
  (document.body || document.documentElement).appendChild(f);
  f.submit();
})();
